module.exports = __webpack_public_path__ + "media/images/arrow-49299956a1b583ea0b196cdb7278aa88.webp";